var EffectMechanic;
(function (EffectMechanic) {
    EffectMechanic["PASSIVE_AURA"] = "PassiveAura";
    EffectMechanic["PASSIVE_PRODUCTION"] = "PassiveProduction";
    EffectMechanic["CULTURE_BONUS"] = "CultureBonus";
    EffectMechanic["PRODUCTION_QUEUE"] = "ProductionQueue";
    EffectMechanic["TRIGGERED_PRODUCTION"] = "TriggeredProduction";
    EffectMechanic["WORKSHOP_PRODUCTION"] = "WorkshopProduction";
    EffectMechanic["HAPPINESS"] = "Happiness";
})(EffectMechanic || (EffectMechanic = {}));
export default EffectMechanic;
